import { render, staticRenderFns } from "./order-icon.vue?vue&type=template&id=cec5b836&"
import script from "./order-icon.vue?vue&type=script&lang=js&"
export * from "./order-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports